import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

// NOTE: This "Our Impact" case-studies section is fully built but intentionally
// hidden for now (wrapped in `hidden`). Remove the `hidden` class on the <section>
// to publish it once real case studies are ready.

const CASES = [
  {
    client: "Global Logistics Group",
    metric: "31%",
    result: "reduction in fulfilment cost",
    desc: "An agentic routing system re-planned 4M shipments a month in real time.",
    img: "https://images.pexels.com/photos/7433919/pexels-photo-7433919.jpeg",
    tag: "Process Automation",
  },
  {
    client: "Tier-1 Retail Bank",
    metric: "5.4×",
    result: "faster credit decisioning",
    desc: "A decision-intelligence layer unified risk models across nine markets.",
    img: "https://images.unsplash.com/photo-1644088379091-d574269d422f",
    tag: "Decision Intelligence",
  },
  {
    client: "Industrial Manufacturer",
    metric: "$42M",
    result: "annual margin recovered",
    desc: "Predictive maintenance and demand models embedded across 12 plants.",
    img: "https://images.unsplash.com/photo-1527576539890-dfa815648363",
    tag: "AI Strategy",
  },
];

const Impact = () => (
  <section id="impact" data-testid="impact-section" className="hidden bg-[#f5f7fb] px-6 py-28 lg:px-12 lg:py-40">
    <div className="mx-auto max-w-[1500px]">
      <div className="mb-16 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <div>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-cobalt">
            / Our impact
          </span>
          <h2 className="mt-6 font-serif text-5xl font-medium leading-[1] tracking-tight text-ink lg:text-7xl">
            Outcomes, not case studies.
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {CASES.map((c, i) => (
          <Reveal key={c.client} delay={i * 0.08}>
            <div className="group cursor-pointer bg-white" data-testid={`case-${i}`}>
              <div className="relative overflow-hidden">
                <img
                  src={c.img}
                  alt={c.client}
                  className="aspect-[4/3] w-full object-cover grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                />
                <span className="absolute left-4 top-4 bg-cobalt px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.12em] text-white">
                  {c.tag}
                </span>
              </div>
              <div className="p-8">
                <div className="font-serif text-6xl font-medium text-cobalt-dark">{c.metric}</div>
                <div className="mt-2 font-mono text-xs uppercase tracking-[0.12em] text-ink/50">
                  {c.result}
                </div>
                <p className="mt-6 text-base font-light leading-relaxed text-ink/70">{c.desc}</p>
                <div className="mt-6 flex items-center justify-between border-t border-black/10 pt-5">
                  <span className="font-mono text-xs uppercase tracking-[0.12em] text-ink">
                    {c.client}
                  </span>
                  <ArrowUpRight size={18} className="text-cobalt" />
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Impact;
